module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'AgreementList'
      }
    }
  }, [_vm._v("Umowy")])], 1), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'AgreementCreate'
      }
    }
  }, [_c('span', [_vm._v("Dodaj umowę")]), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.deletedItem) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.deletedItem['@id']) + " deleted.")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.fullNumber),
      callback: function($$v) {
        _vm.$set(_vm.filter, "fullNumber", $$v)
      },
      expression: "filter.fullNumber"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('date-range-picker', {
    model: {
      value: (_vm.selectedDatePeriod),
      callback: function($$v) {
        _vm.selectedDatePeriod = $$v
      },
      expression: "selectedDatePeriod"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.customer),
      callback: function($$v) {
        _vm.$set(_vm.filter, "customer", $$v)
      },
      expression: "filter.customer"
    }
  }), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "_currency",
      "elements": _vm.currencyTypes,
      "valueField": "id",
      "nameField": "name",
      "showEmpty": true
    },
    model: {
      value: (_vm.filter.currency),
      callback: function($$v) {
        _vm.$set(_vm.filter, "currency", $$v)
      },
      expression: "filter.currency"
    }
  })], 1), _vm._v(" "), _c('td', [_c('dropdown-search', {
    attrs: {
      "id": "status-dropdown",
      "elements": _vm.agreementStatus,
      "showEmpty": true
    },
    model: {
      value: (_vm.filter.status),
      callback: function($$v) {
        _vm.$set(_vm.filter, "status", $$v)
      },
      expression: "filter.status"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "no-wrap"
  }, [_c('my-button', {
    attrs: {
      "variant": "info",
      "action": _vm.getItems
    }
  }), _vm._v(" "), _c('my-button', {
    attrs: {
      "icon": "back",
      "variant": "primary",
      "action": _vm.resetFilter
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('fullNumber'),
    on: {
      "click": function($event) {
        return _vm.setOrder('fullNumber')
      }
    }
  }, [_vm._v("Numer")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('date'),
    on: {
      "click": function($event) {
        return _vm.setOrder('date')
      }
    }
  }, [_vm._v("Data zawarcia")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('customerData.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('customerData.name')
      }
    }
  }, [_vm._v("Klient")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('amount'),
    on: {
      "click": function($event) {
        return _vm.setOrder('amount')
      }
    }
  }, [_vm._v("Kwota")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('leftToPaid'),
    on: {
      "click": function($event) {
        return _vm.setOrder('leftToPaid')
      }
    }
  }, [_vm._v("Do zapłaty")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('currency.name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('currency.name')
      }
    }
  }, [_vm._v("Waluta")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('status'),
    on: {
      "click": function($event) {
        return _vm.setOrder('status')
      }
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Faktura")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['fullNumber']))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("date")(item['date'])))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.customerData.name) + ", NIP: " + _vm._s(item.customerData.nip))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.amount))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.leftToPaid))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.currency.name))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_c('span', {
      staticClass: "element_status",
      class: item.status
    }, [_vm._v(_vm._s(_vm._f("translate")(item['status'])))]), _vm._v(" "), _c('div', {
      staticClass: "payment-status"
    }, [(item.paid) ? _c('span', {
      staticClass: "paid"
    }) : _vm._e(), _vm._v(" "), (item.advancePaymentPaid) ? _c('span', {
      staticClass: "advancePaymentPaid"
    }) : _vm._e()])])], 1), _vm._v(" "), _c('td', [(item.invoice) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'AgreementShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item.invoice.fullNumber))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'AgreementUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1), _vm._v(" "), (item.invoice) ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'InvoiceShow',
          params: {
            id: item.invoice.id
          }
        },
        "title": "Faktura"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "sale_small"
      }
    })], 1) : (item.status == 'closed') ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'InvoiceCreate',
          query: {
            agreement: item['id']
          }
        },
        "title": "Faktura"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "sale_small"
      }
    })], 1) : _vm._e()], 1)])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7853e76","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/List.vue
// module id = 850
// module chunks = 0